import { apiService } from "@/_services";

const ibranch_config = JSON.parse(localStorage.getItem("ibranch_config"));

export default {
  namespaced: true,

  state: {
    data: ibranch_config ? ibranch_config : null,
    updating: false,
    updateRequired: false,
    updateAuto: false,
    updated: null
  },

  getters: {
    isConfig(state) {
      return !!state.data;
    },
    updateAuto(state) {
      return state.updateAuto;
    },
    account(state) {
      return state.data ? state.data.ibranch_account : null;
    },
    user(state, getters) {
      return getters["account"] ? getters["account"].user : null;
    },
    // plan(state, getters) {
    //   return getters["account"] ? getters["account"].plan : null;
    // },
    userPlan(state, getters) {
      return getters["account"] ? getters["account"].plan : null;
    },
    ibranchPlans(state) {
      // return state.data ? state.data.ibranch_plans : null;
      return state.data ? state.data.ibranch_plans : [];
    }
  },

  actions: {
    async getUpdatedData({ commit }) {
      commit("updating", true);
      await apiService.config
        .refresh()
        .then(response => {
          commit("setConfig", response);
        })
        .catch(err => {
          console.log(err);
        });
      commit("updating", false);
    },
    async forceClientUpdate({ dispatch, rootGetters }) {
      if (rootGetters["authentication/loggedIn"]) {
        dispatch("setAutoUpdates", false);
        await dispatch("getUpdatedData");
        dispatch("setAutoUpdates", true);
      }
    },
    setAutoUpdates({ commit }, value) {
      commit("updateAuto", value);
    },
    mutateData({ dispatch, commit }, payload) {
      console.log("mutateData");
      dispatch("setAutoUpdates", false);
      commit("setConfig", payload);
      setTimeout(() => {
        dispatch("setAutoUpdates", true);
      }, 100);
    },
    unsetConfig({ commit }) {
      commit("unsetConfig");
    }
  },

  mutations: {
    setConfig(state, payload) {
      state.data = payload;
      state.updated = new Date().getTime();
    },
    unsetConfig(state) {
      state.data = null;
      state.updated = null;
    },
    updating(state, value) {
      state.updating = value;
    },
    updateAuto(state, value) {
      state.updateAuto = value;
    }
  }
};
